import { render, staticRenderFns } from "./NavigationHorizontal.vue?vue&type=template&id=484e66c1&"
import script from "./NavigationHorizontal.vue?vue&type=script&lang=js&"
export * from "./NavigationHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports